import BaseEvent, {
  BaseGetEvent,
  IBaseEvent,
} from 'hooks/context/EventCollector/events/BaseEvent';

export interface ICheckboxEvent extends IBaseEvent {
  type: 'checkbox';
  toJSON(): BaseGetEvent & {
    type: ICheckboxEvent['type'];
    checkboxChecked: boolean;
  };
}

export default class CheckboxEvent extends BaseEvent implements ICheckboxEvent {
  type = 'checkbox' as const;

  private checkboxChecked: boolean;

  constructor({
    description,
    checkboxChecked,
  }: {
    description: string;
    checkboxChecked: boolean;
  }) {
    super(description);
    this.checkboxChecked = checkboxChecked;
  }

  override toJSON() {
    return {
      ...super.toJSON(),
      type: this.type,
      checkboxChecked: this.checkboxChecked,
    };
  }
}
